import { isNum, limitDecimal } from '@utils/helpers';

/**
 * Ground sample distance is reported by the API in metres per pixel, either as
 * `gsd` or — on older projects — only as a `pixel_dimension` [width, height]
 * pair. Everything user-facing shows it in centimetres, so the conversion lives
 * here rather than at each display site.
 */

/** Averages a non-square pixel into a single metres-per-pixel figure. */
const calculateAvgGsd = pixelDimension => {
	if (!pixelDimension?.length) return;
	const [width, height] = pixelDimension;
	if (!isNum(width) || !isNum(height)) return;
	return (parseFloat(width) + parseFloat(height)) / 2;
};

/**
 * Project GSD in centimetres per pixel, rounded to one decimal.
 *
 * @param {Object} [project] - Project object from `GET /projects/{uuid}`
 * @returns {number|null} cm/px, or null when the project carries no usable GSD
 */
export const getGsdInCm = project => {
	const { gsd, pixel_dimension } = project ?? {};
	const metres = isNum(gsd) ? parseFloat(gsd) : calculateAvgGsd(pixel_dimension);

	if (metres > 0) return limitDecimal(metres * 100);
	return null;
};
